import { useContext } from 'react';

import { ApiContext } from './context';

const useApi = (namespace) => {
  const { namespaces, setNamespaces, ...rest } = useContext(ApiContext);

  if (namespace) {
    return namespaces[namespace];
  }

  return {
    ...rest,

    namespaces,
    addNamespace: (name, instance) => {
      namespaces[name] = instance;
    },
  };
};

export default useApi;

